export async function initHeadroom(options) {
    let { Headroom } = await import(/* webpackMode: "lazy" */ './headroom');

    return new Headroom(options);
}
